
declare var gGDPR_NonTCFVendors: object[];


import { Emit, Component, Prop, Vue } from 'vue-facing-decorator';
import VendorListDivider from './VendorListDivider.vue';
import NonTCFVendorItem from './NonTCFVendorItem.vue';
import VendorListItem from './VendorListItem.vue';

declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

@Component({
  components: {
    VendorListDivider,
    NonTCFVendorItem,
    VendorListItem,
  },
})

export default class LayerThree extends Vue {
  dirty=false;
  vendors : any[] = [] 
  nonTCFVendors : any[] = [] 
  sortedVendorIds : string[]  = []

  mounted() : void {
    if ( gGDPR_NonTCFVendors )
      this.nonTCFVendors = gGDPR_NonTCFVendors

  console.log( "LayerThree mounted()");

  //@ts-ignore
  let model : TCModel = window.__cmpTCModel;

  //@ts-ignore
  this.vendors = Object.freeze( window.__GVL.vendors );

// Yeah, seriously... Build a complicated-ass mess of a library to manage getting in and out of the vendor list,
// but let's skip having any meaningful way to get the vendors in sorted order for display purposes, so now
// every UI related access to the damn list has to go through an intermediate index... Ass hats.

  this.sortedVendorIds = Object.keys( this.vendors ).sort( (a:any, b:any) => this.vendors[a].name.localeCompare(this.vendors[b].name) );

  // this.sortedVendorIds.length = 3;  // for testing without insane number of vendors

  }

  @Emit
	storeAcceptAllTCStringEvent() { }

  @Emit
	storeRejectAllTCStringEvent() { }
  
  @Emit
	storeTCStringEvent() { 
    console.log( "LayerThree: storeTCString()" );

  }

  @Emit('changeViewEvent')
  purposesClick() {
    return( "layerTwo");
  }

  handleModelChangeEvent( value: boolean ) {
    this.dirty=true;
  }

  @Emit('changeViewEvent')
  saveAndExitClick() {
    this.storeTCStringEvent();
    return("close");
  }

  @Emit('changeViewEvent')
  rejectAllClick()  {
		this.storeRejectAllTCStringEvent();
    return("close");
  }

  @Emit('changeViewEvent')
  vendorsClick() {
    return("layerThree");
  }

  @Emit('changeViewEvent')
  acceptAllClick() {
    // // @ts-ignore
    // window.__cmpTCModel.setAll();
    // // @ts-ignore
    // window.__cmpTCModel.purposeLegitimateInterests.empty();
    // // @ts-ignore
    // window.__cmpTCModel.vendorLegitimateInterests.empty();

    // if ( gGDPR_NonTCFVendors  ) {
    //   gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
    //   // @ts-ignore
    //   gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = true;
    //   });
    // }

//@ts-ignore
		this.$root.storeAcceptAllTCString();


// // @ts-ignore
//     this.$root.storeTCString();

    return("close");
  }

}
